/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import draftApi from '../../api/draft.api';

export const postProcessApi = async (submission, event) => {
  let newSubmission = await draftApi.postProcessBusinessRules(submission, event);
  newSubmission = await draftApi.update(submission.id, newSubmission);
  return newSubmission;
};
